import React from 'react';
import './App.scss';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Auth from './pages/auth';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path='/auth/:type' element={<Auth/>} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
